    <h4 mat-dialog-title>Destination Notifications</h4>
    <div class="row" >
      <div class="col-3"  *ngIf="results.PTL.length > 0">  
        <p>Project Team Leader</p>
        <div style="border: 0.0714285714rem solid #cccccc; border-radius: 0.7142857143rem;">         
          <mat-selection-list color="primary" (selectionChange)="onListSelectionChangePTL($event)">
            <mat-list-option *ngFor="let item of results.PTL" [value]="item.mail">
              {{item.displayName}}
            </mat-list-option>
          </mat-selection-list>
        </div>  
      </div>
      <div class="col-3" *ngIf="results.PRM.length > 0">  
        <p>Procurement Fiduciary Spec.</p>
        <div style="border: 0.0714285714rem solid #cccccc; border-radius: 0.7142857143rem;">         
          <mat-selection-list color="primary" (selectionChange)="onListSelectionChangePRM($event)">
            <mat-list-option *ngFor="let item of results.PRM" [value]="item.mail">
              {{item.displayName}}
            </mat-list-option>
          </mat-selection-list>
        </div>  
      </div>
      <div class="col-3"  *ngIf="results.OEG.length > 0">  
        <p>OEG</p>
        <div style="border: 0.0714285714rem solid #cccccc; border-radius: 0.7142857143rem;">         
          <mat-selection-list color="primary" (selectionChange)="onListSelectionChangeOEG($event)">
            <mat-list-option *ngFor="let item of results.OEG" [value]="item.mail">
              {{item.displayName}}
            </mat-list-option>
          </mat-selection-list>
        </div>  
      </div>
      <div class="col-3"  *ngIf="results.OEA.length > 0">  
        <p>OEA</p>
        <div style="border: 0.0714285714rem solid #cccccc; border-radius: 0.7142857143rem;">         
          <mat-selection-list color="primary" (selectionChange)="onListSelectionChangeOEA($event)">
            <mat-list-option *ngFor="let item of results.OEA" [value]="item.mail">
              {{item.displayName}}
            </mat-list-option>
          </mat-selection-list>
        </div>  
      </div>
    </div>
    
    <div class="row bl-finding-form__btn-location-right">
        <div class="col-12">
            <div>
                <button class="bl-button--btn-save" (click)="onSaveClick()" [disabled]="isFinishIcr">
                  Save
                </button>
              </div>
        </div>
    </div>
    
    